import { TranslationKey, Language } from './';

export class Translation {
    public TranslationId:string;

    public TranslationKeyId:string;

    public TranslationKey:TranslationKey;

    public LanguageId:number;

    public Language:Language;

    public TranslatedValue:string;

    constructor(TranslationId:string = "", TranslationKeyId:string = "", LanguageId:number = 0, TranslatedValue:string = ""){
        this.TranslationId = TranslationId;
        this.TranslationKeyId = TranslationKeyId;
        this.LanguageId = LanguageId;
        this.TranslatedValue = TranslatedValue;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/translation.ts